import fetchFactory from '../../../utils/fetchFactory'
import { configEnum } from '../../../enum/fetchFactoryEnum'

export const updateClubActionnaireLastCheck = () => fetchFactory('/api/last/check/clubActionnaire',
	{
		method: configEnum.post
	}
)
